import { useDispatch } from 'react-redux';

import { NsSelector } from 'components/common/ns-selector/NsSelector';
import { FUEL_TYPES, FUEL_NAMES, METER_READ_TYPES } from 'config/app-config';
import { setMeterReadPreferences } from 'state/user-preferences/user-preferences-slice';
import { pushEvent } from 'state/analytics/analytics-slice';

type MeterReadSelectorProps = {
  fuel: typeof FUEL_TYPES[keyof typeof FUEL_TYPES] | 'dual';
  smartMeterByFuel: typeof FUEL_TYPES[keyof typeof FUEL_TYPES][];
};

export const MeterReadSelector = ({
  fuel,
  smartMeterByFuel
}: MeterReadSelectorProps) => {
  const dispatch = useDispatch();

  let decoration;

  switch (fuel) {
    case FUEL_TYPES.ELECTRIC:
      decoration = 'bulb';
      break;
    case FUEL_TYPES.GAS:
      decoration = 'gas';
      break;
    default:
      decoration = 'dual-fuel';
  }

  const displayedFuelName =
    fuel === 'dual' ? 'gas and electricity' : FUEL_NAMES[fuel];

  const handleChange = (event) => {
    const { value } = event.target;
    smartMeterByFuel.forEach((fuel) => {
      dispatch(
        setMeterReadPreferences({
          fuel,
          value: value
        })
      );
      dispatch(
        pushEvent({
          category: 'portal_smartmeter_frequency_final',
          action: fuel,
          label: value
        })
      );
    });
  };

  return (
    <NsSelector
      heading={`How often would you like your smart ${displayedFuelName} meter to send us readings?`}
      name={fuel}
      decoration={decoration}
      onChange={handleChange}
      options={[
        {
          value: METER_READ_TYPES.HALF_HOURLY,
          title: 'Half hourly (recommended)'
        },
        {
          value: METER_READ_TYPES.MONTHLY,
          title: 'Monthly'
        }
      ]}
    />
  );
};
